<template>
  <div class="styled-select-container">
    <select v-model="selectedAmount" @change="emitValue">
      <option v-for="([amount, description], index) in amounts" :key="`${amount}_${index}`" :value="amount">
        {{ formatAmount(amount) }} {{ description ? `- ${description}` : '' }}
      </option>
      <option v-if="!nocustom" value="custom">{{ lang === 'he' ? 'אחר' : 'Other' }}</option>
    </select>
    

<div class="custom__selectypr">
    <FormLabel for="Other Amount"  v-if="selectedAmount === 'custom'">
    Other Amount
    <input
    class="custom__amount"
      type="number"
      min="1"
      v-model="customAmount"
      :placeholder="lang === 'he' ? 'אחר' : 'Other'"
    />
  </FormLabel>
</div>
  </div>
</template>

<script setup lang="ts">
import { computed, nextTick, ref, watch } from 'vue';
import { usePaymentForm } from "~/shared/use-payment-form";

import type { Currency } from "~/form-settings";
import { queryParams } from "~/shared/query-params";

const props = withDefaults(defineProps<{
  nocustom?: boolean
  lang?: string
}>(), {
  nocustom: false,
  lang: 'en'
})

const emit = defineEmits(['update:emittedDescription'])

const { setValue, form, settings } = usePaymentForm()

const selectedAmount = ref<string | number>();
const customAmount = ref(form.value.amount);

const emitValue = () => {
  emit("update:emittedDescription", selectedAmount.value);
      if (selectedAmount.value !== "custom") {
        setValue("amount", selectedAmount.value !== undefined ? String(selectedAmount.value) : null);
      } else {
        setValue("amount", customAmount.value);
      }
    };

    watch(customAmount, async (newVal) => {
      if (selectedAmount.value === "custom" && newVal) {
        await nextTick();
        setValue("amount", newVal);
      }
    });

    const amounts = computed(() => {
      const amounts = settings!.amounts! as [number, string][] | [Partial<{ [key in Currency]: number }>, string][];
      if (typeof amounts[0][0] === "number") return amounts;
      return (amounts as [Partial<{ [key in Currency]: number }>, string][]).map(([amounts, label]) => [amounts[form.value.currency!], label]);
    });

    const params = queryParams();
    if (params.amount) {
      const amountExists = amounts.value.some(([amt]) => amt === +params.amount);
      selectedAmount.value = amountExists ? params.amount : "custom";
      if (!amountExists) customAmount.value = params.amount;
    }

    const formatAmount = (amount: number) => {
      return new Intl.NumberFormat("en-US", { style: "currency", currency: form.value.currency || "USD", minimumFractionDigits: 0 }).format(amount);
    };

</script>

<style scoped lang="scss">
.styled-select-container {
  display: flex;
  flex-direction: column;
  gap: 10px;
  @media only screen and (min-width: 720px) {
      max-width: 50%;
    }
}
select {
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 16px;
}
input[type="number"] {
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 16px;
}

input.custom__amount{
  margin-top: 5px;
}

.custom__selectypr{
  margin-top: 10px;

}
</style>
